// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleModelTab_container__1VFIg"};